export default __webpack_public_path__ + "static/media/nl-site.c7c3ff6a.webp";